export const buildSessionScopeBody = ({
	sessionId,
	examId,
}: {
	sessionId?: number;
	examId?: string;
}) => ({
	...(sessionId ? { sessionId } : {}),
	...(examId ? { examId } : {}),
});
